import React, { useEffect, useState } from 'react';
import css from './StateDropdownField.module.css';
import { DropdownField, DropdownOption } from '../../../../../../core';
import { stateList } from '../../../../../../api/models';

export interface StateDropdownFieldProps {
  selectedState: string;
  required: boolean;
  validate: boolean;
  onSelectionChanged: (stateValue: string) => void;
}

const StateDropdownField: React.FC<StateDropdownFieldProps> = (
  props: StateDropdownFieldProps
) => {
  const [selected, setSelected] = useState<string>(props.selectedState);

  useEffect(() => {
    setSelected(props.selectedState);
  }, [props.selectedState]);

  const stateOptions = stateList.map(
    (state): DropdownOption => ({
      text: state.text,
      value: state.value,
    })
  );
  stateOptions.unshift({ text: '', value: '' });

  const onSelectionChanged = (value: string) => {
    setSelected(value);
    props.onSelectionChanged(value);
  };

  return (
    <div className={css.container}>
      <DropdownField
        selectedValue={selected}
        options={stateOptions}
        label="State"
        required={props.required}
        validate={props.validate}
        onItemPicked={onSelectionChanged}
      />
    </div>
  );
};

export default StateDropdownField;
